import React from 'react';
import { withTranslation } from 'react-i18next';
import { Modal } from 'reactstrap';
import {ModalBody} from 'reactstrap';
import crossIcon from '../../../../assets/images/cross.svg';
import Text from 'components/Text';
import styles from './Modals.module.scss';

function PatientConfirmationModal({ t, title, description, confirmLabel, action, close = () => { } }) {

  return (
    <>
      <Modal
        isOpen={true}
        toggle={close}
        className={
          'modal-dialog-centered modal-width-660 ' +
          styles['confirem-accept-modal-dialog']
        }
        modalClassName='custom-modal'
      >
        <span className='close-btn' onClick={close}>
          <img src={crossIcon} alt='close' />
        </span>

        <ModalBody className='text-center'>
          <Text size='25px' marginBottom='10px' weight='500' color='#111b45'>
            <span className='modal-title-25'>    {title}</span>
          </Text>
          <Text
            size='16px'
            className={styles['desc-text']}
            weight='300'
            color='#535b5f'
          >
            {description}

          </Text>

          <button
            className='button button-round button-shadow mr-md-4 mb-3 w-sm-100'
            title={confirmLabel}
            onClick={action}
          >
            {confirmLabel}
          </button>
          <button
            className='button button-round button-border button-dark btn-mobile-link '
            onClick={close}
            title={t('cancel')}
          >
            {t('cancel')}
          </button>
        </ModalBody>
      </Modal>
    </>
  );
}

export default withTranslation()(PatientConfirmationModal);
